import Theme from '@adsk/alloy-react-theme';

export const containerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
};

export const optionStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  marginRight: '16px',
  marginTop: '16px',
};

export const checkboxStyle = {
  marginTop: '2px',
  input: {
    width: '16px',
    position: 'relative',
  },
};

export const accessOptionTitle = {
  ...Theme.typography.bodyMediumBold,
  marginLeft: '12px',
};

export const accessDescriptionText = {
  color: Theme.colors.charcoal700,
};

export const accessOptionDescription = {
  marginLeft: '12px',
  marginTop: '5px',
};
